import Compressor from 'compressorjs';

export function getBackgroundImage(srcSet = '') {
  const imageSet = srcSet
    .split(', ')
    .map((str) => {
      const [url, dpi] = str.split(' ');
      return `url("${url}") ${dpi}`;
    })
    .join(', ');
  return `image-set(${imageSet})`;
}

export const compressImage = async (file: File) => {
  return new Promise<File>(
    (resolve, reject) =>
      new Compressor(file, {
        retainExif: true,
        success(file) {
          // const parsedFile = new File([file], (file as File).name, {
          //   type: file.type,
          // });
          resolve(file as File);
        },
        error(error) {
          reject(error);
        },
      })
  );
};
